import { TFunction, useTranslation } from 'react-i18next';
import { Button, Card, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import landing from 'assets/img/omnione_logo_color.svg';
import styles from './ProfileComplete.module.less';
import { regionSelector } from 'redux/selectors/regionSelector';
import { userSelector, isUserInfoLoadingSelector } from 'redux/selectors/userSelector';
import { DATE_FORMAT, getFormattedDate } from 'utils/dateUtils';
import { getCountryNameByCode } from 'utils/locationUtils';
import Spin from 'antd/lib/spin';
import moment from 'moment';
import { isEmpty } from 'lodash';

export default function InitialSetupPage() {
	const { t } = useTranslation();
	const userData = useSelector(userSelector);
	const history = useHistory();
	const countries = useSelector(regionSelector);
	const isUserInfoLoading = useSelector(isUserInfoLoadingSelector);

	if (isUserInfoLoading || isEmpty(userData)) return <Spin />;

	return (
		<>
			<div className={styles.landing}>
				<div className={styles.landingLogo}>
					<img src={landing} alt="logo" />
				</div>

				<Col className="d-flex">
					<Card
						title={'Personal Information'}
						className="card"
						extra={
							<>
								<Button
									className="color-dark"
									onClick={() => {
										history.replace('/profile-setup');
									}}
									size="small"
									data-testid="personal-information-edit-button"
								>
									{t('common.Edit')}
								</Button>
							</>
						}
					>
						<ul className="card__list">
							<li>
								<div className="card__label">First Name</div>
								<div className="card__value">{userData?.firstName}</div>
							</li>
							<li>
								<div className="card__label">Last Name</div>
								<div className="card__value">{userData?.lastName}</div>
							</li>
							<li>
								<div className="card__label">Email Address</div>
								<div className="card__value">{userData?.email}</div>
							</li>
							<li>
								<div className="card__label">Date of Birth</div>
								<div className="card__value">
									{userData?.dateOfBirth && moment.parseZone(userData?.dateOfBirth).format(DATE_FORMAT)}
								</div>
							</li>
							<li>
								<div className="card__label">Username</div>
								<div className="card__value">{userData!.userName?.name}</div>
							</li>
							<li>
								<div className="card__label">Country / Region</div>
								<div className="card__value">{getCountryNameByCode(countries, userData?.country)}</div>
							</li>
						</ul>
					</Card>
				</Col>
			</div>
		</>
	);
}
